import { ZERO } from '@drift-labs/sdk';
import useDevSwitchIsOn from 'src/hooks/useDevSwitchIsOn';
import useMarketsInfoStore from 'src/stores/useMarketsInfoStore';
import { AccountOpenPosition } from 'src/@types/positions';

export function useUnclaimablePnlWarning(
	position: AccountOpenPosition
): string | null {
	const isDevMode = useDevSwitchIsOn();

	const pnlPoolValue = useMarketsInfoStore(
		(s) =>
			s.allMarketsInfo.perpLookup[position.marketIndex]?.extendedInfo
				?.pnlPoolValue
	);

	const showWarning =
		isDevMode &&
		position.totalUnrealizedPnl.gt(ZERO) &&
		position.totalUnrealizedPnl.gt(position.unsettledPnl);

	if (!showWarning) return null;

	const isPoolInsufficient =
		!pnlPoolValue || position.totalUnrealizedPnl.gt(pnlPoolValue);

	if (isPoolInsufficient) {
		return 'The P&L pool for this market needs to be topped up before your full P&L can be settled.';
	}

	return 'Close or reduce your position to realize and settle your full P&L. The P&L pool has funds, but open positions are not prioritized for settlement.';
}
